// The selection rules the shared option lists and the Listings Report's Edit Columns both apply. Options are compared
// by their value field rather than by object, since a caller may build its selection apart from its options.
function isSelected<T>(option: T, selection: T[], valueName: keyof T) {
  return selection.some(selected => selected[valueName] === option[valueName]);
}

export function unselectedOptions<T>(options: T[], selection: T[], valueName: keyof T): T[] {
  return options.filter(option => !isSelected(option, selection, valueName));
}

export function matchesSearch(label: string, searchText: string): boolean {
  return label.toLowerCase().includes(searchText.toLowerCase());
}

// The selection keeps its order, and the rest follow in option order.
export function addAll<T>(options: T[], selection: T[], valueName: keyof T): T[] {
  return [...selection, ...unselectedOptions(options, selection, valueName)];
}
